import React from 'react';

import { useService } from '@xstate/react';

import { productImageConfig } from '../../../../constants/productImageConfig';
import { productBuilderMachine } from '../../../../context/ProductBuilder/machine';
import { getBaseProduct } from '../../../../helpers/getBaseProduct';

export const ProductImage = React.forwardRef(
  (
    props: React.SVGProps<SVGSVGElement>,
    setProductImageRef: React.Ref<SVGSVGElement>,
  ) => {
    const [state] = useService(productBuilderMachine);
    const baseProduct = getBaseProduct(state.context);

    let baseProductType = baseProduct
      ? baseProduct.type
      : state.context.products[0].type;

    if (
      window.location.pathname.includes('roller-day-night') &&
      baseProduct &&
      baseProduct.type === 'Roller Blind Single Chain'
    ) {
      baseProductType = 'Roller Blind Day/Night Chain';
    }
    if (
      window.location.pathname.includes('roller-day-night') &&
      baseProduct &&
      baseProduct.type === 'Roller Blind Single Chainless'
    ) {
      baseProductType = 'Roller Blind Day/Night Chainless';
    }
    if (
      window.location.pathname.includes('roller-premium') &&
      baseProduct &&
      baseProduct.type === 'Roller Blind Premium Chain'
    ) {
      baseProductType = 'Roller Blind Premium Chain';
    }

    const ProductImageItem = productImageConfig[baseProductType]
      ? productImageConfig[baseProductType]
      : null;

    if (ProductImageItem) {
      return <ProductImageItem {...props} ref={setProductImageRef} />;
    }
    return null;
  },
);
